import {SVGIconProps} from "../SVGIconProps";
import React from "react";

const ChevronRightIcon = ({
  color,
  size,
  marginRight,
  marginBottom,
  marginTop,
  marginLeft,
  rotation,
}: SVGIconProps): JSX.Element => {
  const sizeString = `${size}px`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={sizeString}
      height={sizeString}
      viewBox="0 0 24 24"
      fill="none"
      style={{
        marginLeft: marginLeft || 0,
        marginRight: marginRight || 0,
        marginTop: marginTop || 0,
        marginBottom: marginBottom || 0,
        transform: rotation ? `rotate(${rotation}deg)` : "rotate(0)",
      }}
    >
      <path
        fill={color}
        d="M16 12l-8-7v14l8-7z"
      />
    </svg>
  );
};

export default ChevronRightIcon;